import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, exibeMensagemAviso, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ButtonBack } from "../Button/Back";
import {formataData, formataDataMesAno} from '../../utils/formatadorData';
import {getMessagemErro} from "../../utils/erro";
import SelectSearch from "../UI/SelectSearch/SelectSearch";
import api from "../../services/api";
import './RelatorioPrestacaoContas.css';
import { baixarArquivo } from "../../utils/downloadUtil";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, exibeMensagemAviso, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
	}
}

export const RelatorioPrestacaoContas =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				tiposContrato: [],
				tipoContrato: '',
				contratos: [],
				contrato: '',
				referencias: [],
				referencia: '',
				orgaos: [],
				orgao: '',
				contratosFornecedoras: [],
				fornecedora: '',
				enviarEmailOrgao: false,
				somenteOrgaosAtivos: true,
				agrupado: false,
				carregandoTiposRelatorio: false,
				carregandoContratos: false,
				carregandoReferencias: false,
				carregandoOrgaos: false,
				carregandoContratosFornecedoras: false,
				botoesHabilitados : true,
				agrupamentoHabilitado: false,
			};
			this.handleInputChange = this.handleInputChange.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.handleTipoRelatorioChange = this.handleTipoRelatorioChange.bind(this);
			this.handleContratoChange = this.handleContratoChange.bind(this);
			this.handleContratoFornecedoraChange = this.handleContratoFornecedoraChange.bind(this);
			this.handleSomenteOrgaosAtivosChange = this.handleSomenteOrgaosAtivosChange.bind(this);
			this.mostraRelatorioPrestacaoContasPDF = this.mostraRelatorioPrestacaoContasPDF.bind(this);
			this.carregarContratos = this.carregarContratos.bind(this);
			this.carregarReferencias = this.carregarReferencias.bind(this);
			this.carregarOrgaosClientes = this.carregarOrgaosClientes.bind(this);
			this.carregarContratosFornecedoras = this.carregarContratosFornecedoras.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Relatório de prestação de contas</h1>
					</div>
					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			this.setState(prevState => ({ ...prevState, carregandoTiposRelatorio: true}))

			api.get('/api/contrato/tipos')
			.then(response => { this.setState(prevState => ({ ...prevState, tiposContrato: response.data})) })
			.catch(erro => {
				console.log("Não foi possível recuperar os tipos de contrato", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			})
			.finally(() => this.setState(prevState => ({ ...prevState, carregandoTiposRelatorio: false})));

		}

		renderForm() {
			const { tipoContrato, contrato, referencia, fornecedora, orgao, agrupamentoHabilitado } = this.state;

			return(
				<div className="container-fluid">
					<div className="br-form">
						<div className="row">
							<div className="col-sm-2">
								<div className="field">
									<div className="input">
										<label htmlFor="tipoContrato">Tipo de Contrato:</label>
										<SelectSearch
											id="tipoContrato"
											name="tipoContrato"
											options={this.state.tiposContrato.map(tipoContrato => ({value: tipoContrato.codigo, label: tipoContrato.nome}))}
											onChange={this.handleTipoRelatorioChange}
											value={tipoContrato}	
										/>
										{this.state.carregandoTiposRelatorio === true && 
										<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>

							{tipoContrato &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="contrato">Contrato:</label>
											{this.state.contratos?.length > 0 &&
												<SelectSearch
													id="contrato"
													name="contrato"
													options={this.state.contratos.map(contrato => ({value: contrato.id.toString(), label: `${contrato.nomeContrato} => ${formataData(contrato.inicioVigencia)} a ${formataData(contrato.fimVigencia)}`}))}
													onChange={this.handleContratoChange}
													value={contrato}	
												/>
											}
											{this.state.carregandoContratos === true && 
												<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
											{this.state.contratos?.length === 0 && !this.state.carregandoContratos && 'Não há contratos cadastrados para o tipo selecionado'}
										</div>
									</div>
								</div>
							}

							{contrato &&
								<div className="col-md">
									<div className="field">
										<div className="input">
											<label htmlFor="contrato">Referência:</label>
											{ this.state.referencias?.length > 0 &&
												<SelectSearch
													id="referencia"
													name="referencia"
													options={this.state.referencias.map(referencia => ({value: referencia.id.toString(), label: `${formataDataMesAno(referencia.referencia)} => ${formataData(referencia.periodoInicial)} a ${formataData(referencia.periodoFinal)}`}))}
													onChange={this.handleInputChange}
													value={referencia}	
												/>
											}
											{this.state.carregandoReferencias === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
											}
											{this.state.referencias?.length === 0 && !this.state.carregandoReferencias && 'Não há referências cadastradas o contrato selecionado.'}
										</div>
									</div>
								</div>
							}

						</div>

						{tipoContrato === 'A'&&
							<div className="row">
								{contrato &&
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label>API:</label>
												{this.state.contratosFornecedoras.length > 0 && 
													<SelectSearch
														id="fornecedora"
														name="fornecedora"
														options={this.state.contratosFornecedoras.map(contratoFornecedora => ({value: contratoFornecedora.idFornecedora.toString(), label: contratoFornecedora.nomeFornecedora}))}
														onChange={this.handleContratoFornecedoraChange}
														value={fornecedora}	
													/>
												}
												{this.state.carregandoContratosFornecedoras === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}

												{this.state.carregandoContratosFornecedoras === false && this.state.contratosFornecedoras.length === 0 && 'Não há APIs cadastradas no contrato selecionado ou não estão configuradas como faturáveis e monitoradas.'}
											</div>
										</div>
									</div>
								}

								{fornecedora && 
									<div className="col-md">
										<div className="field">
											<div className="input">
												<label htmlFor="consumidora">Órgao Consumidor:</label>
												{this.state.orgaos.length > 0 && 
													<SelectSearch
														id="orgao"
														name="orgao"
														includeAllOption={true}
														options={this.state.orgaos.map(orgao => ({value: orgao.id.toString(), label: orgao.nome}))}
														onChange={this.handleInputChange}
														value={orgao}	
													/>
												}
												{this.state.carregandoOrgaos === true && 
													<button className="br-button is-secondary is-circle is-loading" type="button"/>
												}

												{this.state.carregandoOrgaos === false && this.state.orgaos.length === 0 && 'Não há Órgãos para serem selecionados.'}
											</div>
										</div>
									</div>
								}
														
							</div>
						}

						{tipoContrato === 'A'&& contrato &&
							<div className="row">
								<div className="col-md">
									<div className="check">
										<div className="input">
											<input type="checkbox" name="somenteOrgaosAtivos" id="somenteOrgaosAtivos" checked={this.state.somenteOrgaosAtivos} onChange={this.handleSomenteOrgaosAtivosChange} />
											<label for="somenteOrgaosAtivos">Somente órgãos ativos</label>
										</div>
									</div>
								</div>

								{ agrupamentoHabilitado &&
									<div className="col-md">
										<div className="check">
											<div className="input">
												<input type="checkbox" name="agrupado" id="agrupado" checked={this.state.agrupado} onChange={this.handleInputChange} />
												<label for="agrupado">Agrupar API's</label>
											</div>
										</div>
									</div>
								}

								{orgao &&
									<div className="col-md">
										<div className="check">
											<div className="input">
												<input type="checkbox" name="enviarEmailOrgao" id="enviarEmailOrgao" checked={this.state.enviarEmailOrgao} onChange={this.handleInputChange} />
												<label for="enviarEmailOrgao">Enviar relatório para o órgão</label>
											</div>
										</div>
									</div>
								}
							</div>
						}

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.mostraRelatorioPrestacaoContasPDF} disabled={!this.state.botoesHabilitados}>Relatório PDF</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>


					</div>
				</div>
			);
		}

		validaFormulario() {

			let mensagens = [];
			const {tipoContrato, contrato, fornecedora, referencia} = this.state;

			if(!tipoContrato || tipoContrato.trim().length === 0 ){
				mensagens.push({mensagem: "Tipo de Contrato é obrigatório."})
			} else {
				if(!contrato || contrato.trim().length === 0 ){
					mensagens.push({mensagem: "Contrato é obrigatório."})
				} else {
					if(!referencia || referencia.trim().length === 0 ){
						mensagens.push({mensagem: "Referência é obrigatório."})
					}
					if(tipoContrato === 'A' && !fornecedora){
						mensagens.push({mensagem: "API é obrigatório."})
					}
				}
			}

			if(mensagens.length > 0){
				this.props.exibeMensagemErro("Não foi possível realizar a operação porque há inconsistências nos campos informados:", mensagens)
				throw new Error("Formulário não preenchido corretamente.");
			}
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState(prevState => ({ ...prevState, [nome]: valor}));
		}

		handleTipoRelatorioChange(evento){
			const tipoContrato =  evento.target.value;

			this.setState(prevState => ({ 
				...prevState, 
				tipoContrato,
				contrato: '',
				contratos: [],
				referencia: '',
				referencias: [],
				fornecedora: '',
				contratosFornecedoras: [],
				orgao: '',
				orgaos: [],
				somenteOrgaosAtivos: true,
				enviarEmailOrgao: false,
				agrupamentoHabilitado: false,
			}));
			this.carregarContratos(tipoContrato);
		}

		handleContratoChange(evento){
			const contrato = evento.target.value;

			this.setState(prevState => ({ 
				...prevState, 
				contrato,
				referencia: "",
				referencias: [],
				fornecedora: '',
				contratosFornecedoras:[],
				agrupamentoHabilitado: false,
			}))

			this.carregarReferencias(contrato);
			if(this.state.tipoContrato === 'A') {
				this.carregarContratosFornecedoras(contrato);
			}
		}

		handleContratoFornecedoraChange(evento){
			const fornecedora = evento.target.value;
			let agrupamentoHabilitado = false;
			const user = this.props.user;

			if(fornecedora && (user.isAdministrador || user.isMantenedor)) {
				const contratoFornecedora = this.state.contratosFornecedoras.find(contratoFornecedora => contratoFornecedora.idFornecedora === Number(fornecedora));
				agrupamentoHabilitado = contratoFornecedora && contratoFornecedora.idGrupo;
			}

			this.setState(prevState => ({ 
				...prevState, 
				fornecedora,
				orgao: "",
				orgaos: [],
				enviarEmailOrgao: false,
				agrupamentoHabilitado,
			}))

			this.carregarOrgaosClientes(fornecedora, this.state.somenteOrgaosAtivos);
		}

		handleSomenteOrgaosAtivosChange(evento){
			const somenteOrgaosAtivos = evento.target.checked;

			this.setState(prevState => ({ 
				...prevState, 
				somenteOrgaosAtivos,
				orgao: "",
				orgaos: [],
				enviarEmailOrgao: false,
			}))

			this.carregarOrgaosClientes(this.state.fornecedora, somenteOrgaosAtivos);
		}

		carregarContratos(tipoContrato) {
			if( !tipoContrato) {
				return;
			}

			this.setState(prevState => ({ ...prevState, carregandoContratos : true }));
			api.get(`/api/contrato/tipo/${tipoContrato}`)
				.then(response => { 
					const contratos = response.data;
					this.setState(prevState => ({ ...prevState, 	contratos	}))
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os contratos", erro)
					this.props.exibeMensagemErro("Erro durante o carregamento dos contratos")
				})
				.finally(() => {
					this.setState(prevState => ({ ...prevState, carregandoContratos : false}));
				});
		}

		carregarReferencias(contrato) {
			if( !contrato) {
				return;
			}
			this.setState(prevState => ({ ...prevState, carregandoReferencias : true }));
			api.get(`/api/referencia-faturamento/contrato/${contrato}`)
			.then(response => { 
				const referencias = response.data;
				this.setState(prevState => ({ ...prevState, 	referencias	}))
			 })
			.catch(erro => {
				console.log("Não foi possível recuperar as referências de faturamento do contrato", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento das referências de faturamento do contrato")
			})
			.finally(() => {
				this.setState(prevState => ({ ...prevState, carregandoReferencias : false}));
			});
		}

		carregarContratosFornecedoras(contrato) {
			if( !contrato) {
				return;
			}

			this.setState(prevState => ({ ...prevState, carregandoContratosFornecedoras : true}));

			api.get(`/api/contrato/${contrato}/apis-faturaveis-monitoradas`)
			.then(response => { this.setState(prevState => (
				{ ...prevState, 
					contratosFornecedoras: response.data,
				})) 
			})
			.catch(erro => {
				console.log("Não foi possível recuperar as aplicações fornecedoras do contrato ", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento das APIs do contrato")
			})
			.finally(() => this.setState(prevState => ({ ...prevState, carregandoContratosFornecedoras: false})));
		}

		carregarOrgaosClientes(fornecedora, ativos) {
			if( !fornecedora) {
				return;
			}
			this.setState(prevState => ({ ...prevState, carregandoOrgaos : true }));
			api.get(`/api/orgao/consumidores/fornecedora/${fornecedora}?ativos=${ativos ? true : ''}`)
			.then(response => { 
				const orgaos = response.data;
				this.setState(prevState => ({ ...prevState, 	orgaos,	}))
			 })
			.catch(erro => {
				console.log("Não foi possível recuperar os órgãos consumidores da API", erro)
				this.props.exibeMensagemErro("Erro durante o carregamento dos órgãos consumidores da API")
			})
			.finally(() => {
				this.setState(prevState => ({ ...prevState, carregandoOrgaos : false}));
			});
		}

		mostraRelatorioPrestacaoContasPDF(e){
			try{
				this.validaFormulario();
			}catch(erroValidacao){
				e.preventDefault();
				return;
			}

			const {referencia, fornecedora, orgao, enviarEmailOrgao, agrupado } = this.state;
			const criterioPesquisa = { referencia, fornecedora, orgao, enviarEmailOrgao, agrupado};

			const options = {
				method: 'post',
				url: '/api/prestacao-contas/relatorio/pdf',
				data: criterioPesquisa,
				responseType: 'arraybuffer'
			}

			this.props.limpaMensagem();
			this.props.mostraAguardando();
			this.setState(prevState => ({ ...prevState, botoesHabilitados : false}));

			api(options)
				.then((response) => {
					let nomeRelatorio = 'RelatorioPrestacaoContas.pdf';

					const contentDisposition = response['headers']['content-disposition'];
					if(contentDisposition) {
						nomeRelatorio = contentDisposition.split("filename=")[1];
					}

					baixarArquivo(new Blob([response.data]), nomeRelatorio);

					const mensagem = response['headers']['mensagem'];
					if(mensagem) {
						this.props.exibeMensagemAviso(mensagem);
					}
				})				
				.catch(response => {
					const erro = {data: JSON.parse(Buffer.from(response.data).toString('utf8'))};
					const mensagemInicial = 'Não foi possível recuperar o relatório de prestação de contas';
					const msg = getMessagemErro(mensagemInicial, erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
					this.setState(prevState => ({ ...prevState, botoesHabilitados : true}));
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();

			this.setState(prevState => ({ 
				...prevState, 
				tipoContrato: '',
				orgao: '',
				orgaos: [],
				fornecedora: '',
				contrato: '',
				contratos: [],
				referencia: '',
				referencias: [],
				somenteOrgaosAtivos: true,
				agrupado: false,
				enviarEmailOrgao: false,
				agrupamentoHabilitado: false,
			}));
		}
	}

) // redux
); // router